// utils/axiosRequestManager.ts
export class AxiosRequestManager {
  // Store controllers keyed by the URL
  private static controllerMap: Map<string, AbortController> = new Map();
  // Add or replace the controller for a given API endpoint
  static addController(key: string, controller: AbortController) {
    const existingController = this.controllerMap.get(key);
    if (existingController) {
      existingController.abort(); // Abort previous request if exists
    }
    this.controllerMap.set(key, controller); // Store the new controller
  }

  // Remove controller after request is complete
  static removeController(key: string) {
    this.controllerMap.delete(key);
  }
  // Get the controller by the unique key
  // Get the controller by the unique key (method + URL)
  static getController(key: string): AbortController | undefined {
    return this.controllerMap.get(key);
  }
  // Cancel all ongoing requests (global cancel)
  static cancelAll() {
    this.controllerMap.forEach((controller) => controller.abort());
    this.controllerMap.clear();
  }
  // private static controllers: AbortController[] = [];

  // static addController(controller: AbortController) {
  //   this.controllers.push(controller);
  // }

  // static cancelAll() {
  //   this.controllers.forEach((controller) => controller.abort());
  //   this.controllers = []; // Clear after cancel
  // }
}
